import React, { useEffect } from "react";
import {
    Box,
    CircularProgress,
    Typography,
} from "@mui/material";

import AppTable from "components/Shared/AppTable"; 
import { useLazyGetShipmentLogsQuery } from "store/services/shipmentApi";
import moment from "moment";

export const ShipmentChangeLogs = ({ shipmentId }) => {
    const [getShipmentLogs, { data: logsData, isLoading, isFetching, error }] =
        useLazyGetShipmentLogsQuery();

    useEffect(() => {
        if (shipmentId) {
            getShipmentLogs(shipmentId);
        }
    }, [shipmentId, getShipmentLogs]);

    // Loading state
    if (isLoading || isFetching) {
        return (
            <Box display="flex" alignItems="center" justifyContent="center" padding={4}>
                <CircularProgress size={24} />
                <Typography variant="body2" marginLeft={1}>
                    Loading Change Logs...
                </Typography>
            </Box>
        );
    }

    // Error
    if (error) {
        return (
            <Box padding={2}>
                <Typography color="error" variant="body2">
                    Error loading change logs: {error?.data?.message || "Something went wrong"}
                </Typography>
            </Box>
        );
    }

    const changeLogs = logsData?.data?.details || [];

    // Empty
    if (!changeLogs.length) {
        return (
            <Typography variant="body2" padding={2} textAlign="center" color="textSecondary">
                No change logs found for this shipment.
            </Typography>
        );
    }

    // 🔥 New Table Columns (Same style as ShipmentPricingList)
    const columns = [
        {
            name: "Changed Field",
            selector: (row) => row.field,
            sortable: true,
            cell: (row) => (
                <Typography fontWeight="500" sx={{ textTransform: "capitalize" }}>
                    {row.field.replace(/_/g, " ")}
                </Typography>
            ),
        },
        {
            name: "Old Value",
            selector: (row) => row.oldValue,
            sortable: true,
            cell: (row) => (
                row.oldValue
            ),
        },
        {
            name: "New Value",
            selector: (row) => row.newValue,
            sortable: true,
            cell: (row) => (
                row.newValue
            ),
        },
        {
            name: "Changed By",
            selector: (row) => row.changedBy?.name,
            sortable: true,
            cell: (row) => row.changedBy?.name || "Unknown",
        },
        {
            name: "Time",
            selector: (row) => row.createdAt,
            sortable: true,
            cell: (row) => moment(row.createdAt).format("MMM D, YYYY HH:mm"),
        },
    ];

    return (
        <Box>
            <AppTable
                columns={columns}
                data={changeLogs}
                progressPending={false}
                pagination={false}
                highlightOnHover
                striped
                noDataComponent={
                    <Typography variant="body2" padding={2}>
                        No change logs found.
                    </Typography>
                }
            />
        </Box>
    );
};
